var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3833 2.55005H5.58329C4.23329 2.55005 3.18329 3.60005 3.18329 4.95005V42.75C3.18329 44.1 4.23329 45.15 5.58329 45.15H43.3833C44.7333 45.15 45.7833 44.1 45.7833 42.75V5.10005C45.9333 3.75005 44.7333 2.55005 43.3833 2.55005ZM7.08329 12H42.3333V15H7.08329V12ZM7.08329 18.75H42.3333V21.75H7.08329V18.75ZM7.08329 25.35H42.3333V28.35H7.08329V25.35ZM25.5333 41.85H7.08329V38.85H25.5333V41.85ZM25.5333 35.1H7.08329V32.1H25.5333V35.1ZM42.3333 41.85H28.2333V31.95H42.3333V41.85Z",
    fill: "#79C8B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3833 2.55005H5.58329C4.23329 2.55005 3.18329 3.60005 3.18329 4.95005V42.75C3.18329 44.1 4.23329 45.15 5.58329 45.15H43.3833C44.7333 45.15 45.7833 44.1 45.7833 42.75V5.10005C45.9333 3.75005 44.7333 2.55005 43.3833 2.55005ZM7.08329 12H42.3333V15H7.08329V12ZM7.08329 18.75H42.3333V21.75H7.08329V18.75ZM7.08329 25.35H42.3333V28.35H7.08329V25.35ZM25.5333 41.85H7.08329V38.85H25.5333V41.85ZM25.5333 35.1H7.08329V32.1H25.5333V35.1ZM42.3333 41.85H28.2333V31.95H42.3333V41.85Z",
    fill: "url(#paint0_linear_109_9967)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_9967",
    x1: 37.8061,
    y1: 38.05,
    x2: 13.0682,
    y2: 14.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.d46d8ea74c831007c5dd57d7f8b2d157.svg";
export { ForwardRef as ReactComponent };